import { render, staticRenderFns } from "./DashboardDetail.vue?vue&type=template&id=af89cf42&scoped=true"
import script from "./DashboardDetail.vue?vue&type=script&lang=js"
export * from "./DashboardDetail.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetail.vue?vue&type=style&index=0&id=af89cf42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af89cf42",
  null
  
)

export default component.exports